import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { SettingsController } from '@hub/generated/services';
import { AuthService } from '@hub/services/AuthService';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CurrentUserService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    private _isLoadedCurrentUser = false;

    constructor(private settingsController: SettingsController, private auth: AuthService,
      private currentUser: CurrentUserService, private router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      if (!this.auth.isLogged) {
        this.auth.redirectUrl = state.url;
        this.router.navigate(['/login'])

        return of(false);
      }

      if (this._isLoadedCurrentUser) {
          return of(true);
      }

      return this.settingsController.GetCurrentUser()
        .pipe(map(user => {
              this.currentUser.load(user);
              this._isLoadedCurrentUser = true;
              return true;
          }),
          catchError(err => {
              this.router.navigate(['/unauthorized']);
              return of(false);
          })
      );
    }
}
